<template>
  <div>
    <div>
      <h1 class="mt-100 center">
        Welcome to Nylas Authentication Page.
      </h1>
    </div>
    <modal name="sign-in-with-google"  height="auto" :scrollable="false" class="modal-dialog modal-sm modal--custom">
      <div tabindex="-1" role="dialog">
          <div  role="document">
              <div class="modal-content o-common-modal-content otb-modal-content">
                  <div class="modal-header text-center">
                      <!-- <button @click="closeSignInWithGoogle()" type="button" class="close otb-close custom-modal--close otb-modal--close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button> -->
                      <h1 class="modal-title">Please Sign-in</h1>
                  </div>
                  <div class="modal-body">
                      <div class="otb-conflict-body">
                          You are using Gmail, So you need to sign in again to your gmail account to use the Nylas Calendar Integration
                      </div>   
                  </div>                        

                  <div class="modal-footer text-center">
                    <div class="form-group">
                        <div class="clearfix signin_options">
                            <a href="javascript: void(0)" v-google-signin-button="clientId" class="sign-in-google">
                                <div>
                                    <img src="static/assets/images/Google-512.webp" width="20px" />
                                </div>
                                <div class="button-font">
                                    <span>
                                    Sign in  with Google
                                    </span>
                                </div>
                            </a>
                        </div>
                      </div>
                      <!-- <a id="btn-bulk-assign-modal" href="javascript: void(0)" @click="closeSignInWithGoogle()" class="c-common-btn c-common-btn--small otb-modal-cancel-btn"> Cancel</a> -->
                      <!-- <a id="btn-bulk-assign-modal" href="javascript: void(0)" @click="proceedSignIn()" class="c-common-btn c-common-btn--small otb-modal-proceed-btn">Proceed</a> -->
                  </div>
              
              </div>
              <!-- /.modal-content -->
          </div>
            <!-- /.modal-dialog -->
      </div>
    </modal>
  </div>
</template>

<script>
import service from '../../services.js';
import { mapGetters } from 'vuex';
import GoogleSignInButton from 'vue-google-signin-button-directive'

export default {
  data() {
    return{
      clientId: "508718336686-s1b3dg4trrs2fk287qsegbregbthkiuu.apps.googleusercontent.com",
      googleResponseMessage: ''
    };
  },
  computed: {
      ...mapGetters({
          userToken: 'userToken',
          userID:'userID'          
      }),
      deviceDetector() {
          let userAgent = navigator.userAgent.toLowerCase();

          const check =(/(ipad|tablet|(android(?!.*mobile))|(windows(?!.*phone)(.*touch))|kindle|playbook|silk|(puffin(?!.*(IP|AP|WP))))/.test(userAgent) ? "tablet" : /(mobi|ipod|phone|blackberry|opera mini|fennec|minimo|symbian|psp|nintendo ds|archos|skyfire|puffin|blazer|bolt|gobrowser|iris|maemo|semc|teashark|uzard)/.test(userAgent) ? "phone" : "desktop");
          console.log(check);        
          return("desktop" != check ? !0 : !1);
      },
  },
  components:{},
  methods: {
    OnGoogleAuthSuccess (idToken) {
      console.log(idToken);
      if(idToken) {
        this.$modal.hide("sign-in-with-google");
        this.$notify({
            type: 'success',
            title: this.$t('success'),
            message: this.googleResponseMessage
        });
        this.googleResponseMessage = '';
        this.$router.push({
            path: '/myProfile',
            name: 'myProfile'
        });
      }
        // this.loginWithGoogle(idToken); // Receive the idToken and make your magic with the backend
    },

    OnGoogleAuthFail (err) {
        // console.log(err.error);
        this.$notify.error({
            title: 'Error',
            message: err.error
        })
    },
    loginWithGoogle(idToken) {
                // console.log(idToken);
        this.$Progress.start();
        // console.log("Google Connection")
        service
        .post('auth/socialLogin', {
            url: window.location.href,
            idToken: idToken
        })
        .then(async (res) => {
            await this.getIntoApp(res);
        })
        .catch((err) => {
            this.$Progress.fail();
            this.credential_err = this.$t('something_went_wrong');
        });
    },
    saveNylasAccessToken(){
      // console.log("Check1");
      let header = {
        'Authorization': this.userToken      }
      let params = {
        'state' : this.$route.query &&this.$route.query.state?this.$route.query.state:null,
        // 'state' : 'nullState',
        'code': this.$route.query &&this.$route.query.code?this.$route.query.code:null
      }
      service.post('employee/getAccessTokenNylas',params,header)
      .then((res) => {
          if(res.data) {
            this.googleResponseMessage = res.data.status_message
            this.$notify({
                  type: 'success',
                  title: this.$t('success'),
                  message: this.googleResponseMessage
              });
              this.googleResponseMessage = '';
              this.$router.push({
                  path: '/myProfile',
                  name: 'myProfile'
              });
          }
      }).catch(async(err) => {
          console.log(err.response.data);
          this.$notify({
              type: 'error',
              title: this.$t('error'),
              message: 'Something went wrong!'
          });
          if(err.response.data.status_code=='0') {
            await this.cancelStripeSubscription();
            this.$router.push({
              path:'/myProfile',
              name: 'myProfile'
            });
          }
      });
    },
    async cancelStripeSubscription() {
        this.dataAvailable = false;
      await service.post('employee/cancelStripeSubscription',{
        user_id: this.userID
        }, {
            'Authorization': this.userToken
        }).then((res) => {
            // console.log(res.data);
            // this.getEmpDetails();
            if(res.data) {                   
                this.$notify({
                    type: 'success',
                    title: this.$t('success'),
                    message: res.data.status_message
                });
            }
        }).catch((err) => {
            console.log(err);
        });
    },
  },
  directives: {
    GoogleSignInButton
  },
  created() {
    const isMobile = this.deviceDetector;
    if(!isMobile){
      // console.log("Desktop");
      this.saveNylasAccessToken();
    }else {
      console.log(window.location.href);
      console.log(window.location.href.split('#')[0]+'mobile/#/'+window.location.href.split('#')[1]);
      window.location.href = window.location.href.split('#')[0]+'mobile/#'+window.location.href.split('#')[1]
    }
  },
}
</script>

<style scoped>
.signin_options {        
        /* display: flex;
        flex-direction: column;
        justify-content: center; */
    }

    .login-center {
        left: 60%;
    }

    .signin_options .sign-in-google {
        display: flex;
        flex-direction: row;
        justify-items: center;
        width: 200px;
        height: 36px;
        border-radius: 5px;
        padding: 0;
        background-color: #4285F4;
    }

    .signin_options .sign-in-google div img {
        background-color: #FFFFFF;
        height: 34px;
        width: 34px;
        border-top-left-radius: 5px;
        border-bottom-left-radius: 5px;

    }

    .signin_options .sign-in-google .button-font{
        margin-top: 10px;
    }

    .signin_options .sign-in-google .button-font span {
        color: #FFFFFF;
        font-size: 16px;
        vertical-align: middle;
        padding: 10px 5px;
        font-weight: 500;
        font-family: 'Roboto', 'Helvetica';
    }
.otb-conflict-body {
  line-height: 1.5;
  font-size: 15px;
  font-weight: 500;
  padding: 10px 10px 0;
}
.mt-100{
  margin-top: 100px;
}
.center{
  text-align: center;
}

</style>



// WEBPACK FOOTER //
// src/components/userProfile/authNylas.vue